import { ref, computed } from 'vue';

/**
 * Anomalies & insights (v3 homepage) — live data for the V3Insights widget,
 * from `POST Report/anomalies`: org-level governance rows (function-level
 * grade skew, anomaly rollup, rationale/scoring gaps), each
 * { kind, sev: 'high'|'med'|'low', icon, title, detail, count } sorted
 * high → low severity by the endpoint. `self` pattern; caller injects an
 * axios-like `http`.
 *
 * @param {Object} options
 * @param {{post:Function}} options.http
 * @param {() => number} [options.getLimit] rows to request (default 6)
 * @param {() => void} [options.onReady] called once after the first load settles
 */
export function anomalies(options) {
  const { http, getLimit = () => 6, onReady = () => {} } = options || {};

  const self = { rows: ref([]), loading: ref(false) };

  self.isLoading = computed(() => self.loading.value);
  self.count = computed(() => self.rows.value.length);

  // Severity → the .v3-anom-ic tone class suffix (high/med/low, prototype V3Insights).
  self.sevClass = (r) => 'v3-anom-ic--' + (r && (r.sev === 'high' || r.sev === 'med' || r.sev === 'low') ? r.sev : 'low');

  let didReady = false;
  function signalReady() {
    if (!didReady) {
      didReady = true;
      onReady();
    }
  }

  async function load() {
    self.loading.value = true;
    try {
      const resp = await http.post('Report/anomalies', { limit: getLimit() || 6 });
      const data = (resp && resp.data && (resp.data.Data ?? resp.data)) || [];
      self.rows.value = Array.isArray(data) ? data : [];
    } catch {
      self.rows.value = [];
    } finally {
      self.loading.value = false;
      signalReady();
    }
  }

  load();

  return self;
}
